import React from 'react';

function DiagonalArrow() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
    >
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#1FB6FF" fillRule="nonzero" transform="translate(-146 -9)">
          <path d="M151.503 9c.275 0 .497.222.497.497v3.972a.497.497 0 01-.993 0l-.001-2.64-3.975 4.021a.5.5 0 01-.707.004l-.178-.18a.5.5 0 010-.703l3.932-3.978h-2.548a.497.497 0 010-.993h3.973z" />
        </g>
      </g>
    </svg>
  );
}

export default DiagonalArrow;



// WEBPACK FOOTER //
// ./src/components/modules/Examples/DiagonalArrow.js